import { getLocaleByPurchaseCountry } from '@nemuru-eng/js-api-client';
import { useEffect, useState } from 'react';

import { useCheckoutSession } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/hooks/useCheckoutSession';
import { BnplPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Bnpl/_shared/entities/PaymentMethodDetail/BnplPaymentMethodDetailEntity';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useNemuruJs } from '@/hooks/useNemuruJs';

interface RefundButtonProps {
  paymentMethodDetailEntity: BnplPaymentMethodDetailEntity;
}

export const RefundButton = ({ paymentMethodDetailEntity }: RefundButtonProps) => {
  if (!paymentMethodDetailEntity.orderCanBeRefunded()) {
    return null;
  }

  return <Refunds paymentMethodDetailEntity={paymentMethodDetailEntity} />;
};

const Refunds = ({ paymentMethodDetailEntity }: RefundButtonProps) => {
  const { refreshCheckoutSessionAndPaymentMethodEntities } = useCheckoutSession();

  const { loadNemuruJsWithAgent, openOrderManagement } = useNemuruJs();

  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    loadNemuruJsWithAgent(paymentMethodDetailEntity.checkoutSession.agentId, {
      currency: paymentMethodDetailEntity.checkoutSession.cart.totalPriceWithTax.currency,
      locale: getLocaleByPurchaseCountry(paymentMethodDetailEntity.checkoutSession.purchaseCountry),
    }).then(() => {
      setInitialized(true);
    });
  }, [paymentMethodDetailEntity.checkoutSession.agentId]);

  const loanId = paymentMethodDetailEntity.paymentMethodId;

  if (!loanId) {
    return null;
  }

  const onClose = () => {
    refreshCheckoutSessionAndPaymentMethodEntities();
  };

  const options = {
    onClose,
  };

  return (
    <StandardButton
      size="small"
      variant="outlined"
      disabled={!initialized}
      onClick={() => openOrderManagement(loanId, options)}
      style={{ flexShrink: 0 }}
    >
      <Text tId={'REFUND'} />
    </StandardButton>
  );
};
